{
  "INBOX_MGMT": {
    "HEADER": "Schránky",
    "DESCRIPTION": "Kanál je spôsob komunikácie, ktorý si zákazník vyberie pre interakciu s vami. Schránka je miesto, kde spravujete interakcie pre konkrétny kanál. Môže zahŕňať komunikáciu z rôznych zdrojov, ako je e-mail, živý chat a sociálne siete.",
    "LEARN_MORE": "Zistiť viac o schránkach",
    "RECONNECT": {
      "BUTTON": "Znova pripojiť",
      "FACEBOOK": "Pripojenie k Facebooku vypršalo alebo bolo zrušené. Správy odoslané na stránku do tejto schránky neprídu a odpovede sa nemusia odoslať. Osoba, ktorá spravuje facebookovú stránku, musí kliknúť na Znova pripojiť a prihlásiť sa na Facebook.",
      "INSTAGRAM": "Pripojenie k Instagramu vypršalo alebo bolo zrušené. Správy odoslané na účet do tejto schránky neprídu a odpovede sa nemusia odoslať. Kliknite na Znova pripojiť a prihláste sa do rovnakého instagramového účtu. Iný účet vytvorí novú schránku.",
      "GOOGLE": "Pripojenie ku Googlu vypršalo alebo bolo zrušené. Nové e-maily do tejto schránky neprídu a odpovede sa nemusia odoslať. Kliknite na Znova pripojiť a prihláste sa do Googlu ako {email}.",
      "MICROSOFT": "Pripojenie k Microsoftu vypršalo alebo bolo zrušené. Nové e-maily do tejto schránky neprídu a odpovede sa nemusia odoslať. Kliknite na Znova pripojiť a prihláste sa do Microsoftu ako {email}.",
      "ALLEGRO": "Pripojenie k Allegru vypršalo alebo bolo zrušené. Správy od kupujúcich do tejto schránky neprídu a odpovede sa nemusia odoslať. Kliknite na Znova pripojiť a prihláste sa do Allegra ako predajca {seller}. Iný predajný účet vytvorí novú schránku.",
      "IMAP_LOGIN": "Poštový server odmieta prihlásenie k IMAP ako {login}. Nové e-maily do tejto schránky neprídu. Skontrolujte prihlasovacie meno a heslo pre IMAP na karte {tab} a uložte ich. Prihlásenie skúšame ďalej a schránka sa obnoví, hneď ako prihlásenie prejde.",
      "WHATSAPP": "Pripojenie k WhatsAppu vypršalo alebo bolo zrušené. Prílohy od zákazníkov do tejto schránky neprídu a odpovede môžu zlyhať. Kliknite na Znova pripojiť, prihláste sa na Facebook a znova vyberte číslo {phone}."
    },
    "LIST": {
      "404": "K tomuto účtu nie sú pripojené žiadne schránky.",
      "RECONNECT_REQUIRED": "Je potrebné znova pripojiť"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Vyberte kanál",
        "BODY": "Vyberte poskytovateľa, ktorého chcete integrovať."
      },
      "INBOX": {
        "TITLE": "Vytvoriť schránku",
        "BODY": "Overte svoj účet a vytvorte schránku."
      },
      "AGENT": {
        "TITLE": "Pridať agentov",
        "BODY": "Pridajte agentov do vytvorenej schránky."
      },
      "FINISH": {
        "TITLE": "Hotovo!",
        "BODY": "Všetko je pripravené!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Meno schránky",
        "PLACEHOLDER": "Zadajte názov schránky (napr.: Acme Inc)",
        "ERROR": "Zadajte prosím platný názov schránky"
      },
      "WEBSITE_NAME": {
        "LABEL": "Názov webovej stránky",
        "PLACEHOLDER": "Zadajte názov vašej webovej stránky (napr.: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: Prihlásením získame prístup iba k správam vašej stránky. K vašim súkromným správam nikdy nebudeme mať prístup.",
        "CHOOSE_PAGE": "Vyberte stránku",
        "CHOOSE_PLACEHOLDER": "Vyberte stránku zo zoznamu",
        "INBOX_NAME": "Meno schránky",
        "ADD_NAME": "Pridať meno pre vašu schránku",
        "PICK_NAME": "Vyberte názov pre vašu schránku",
        "PICK_A_VALUE": "Vybrať hodnotu",
        "CREATE_INBOX": "Vytvoriť schránku"
      },
      "TWITTER": {
        "HELP": "Ak chcete pridať svoj profil na Twitteri ako kanál, musíte overiť svoj profil Twitter kliknutím na \"Prihlásiť sa pomocou Twitteru\" ",
        "ERROR_MESSAGE": "Pri pripájaní k službe Twitter došlo k chybe, skúste to prosím znova",
        "TWEETS": {
          "ENABLE": "Vytvoriť konverzácie zo zmienených tweetov"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Webový kanál",
        "DESC": "Vytvorte si kanál pre svoje webové stránky a začnite podporovať svojich zákazníkov prostredníctvom nášho webového widgetu.",
        "LOADING_MESSAGE": "Vytvorenie kanála webovej podpory",
        "CHANNEL_AVATAR": {
          "LABEL": "Logo kanálu"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "URL webhooku",
          "PLACEHOLDER": "Zadajte prosím Webhook URL",
          "ERROR": "Prosím zadajte platnú URL"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Webová doména",
          "PLACEHOLDER": "Zadajte doménu svojej webovej stránky (napr.: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Uvítací nadpis",
          "PLACEHOLDER": "Zdravím!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Uvítací slogan",
          "PLACEHOLDER": "Spojenie s nami je jednoduché. Spýtajte sa nás na čokoľvek alebo sa podeľte o svoju spätnú väzbu."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Uvítacia správa kanála",
          "PLACEHOLDER": "Acme zvyčajne odpovedá do niekoľkých hodín."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Povoliť pozdav v kanáli",
          "HELP_TEXT": "Automatically send a greeting message when a new conversation is created.",
          "ENABLED": "Zapnuté",
          "DISABLED": "Vypnuté"
        },
        "REPLY_TIME": {
          "TITLE": "Nastaviť čas odpovede",
          "IN_A_FEW_MINUTES": "O pár minút",
          "IN_A_FEW_HOURS": "O pár hodín",
          "IN_A_DAY": "O deň",
          "HELP_TEXT": "Tento čas odpovede sa zobrazí na widgete živého chatu"
        },
        "WIDGET_COLOR": {
          "LABEL": "Farba widgetu",
          "PLACEHOLDER": "Zmeniť farbu widgetu použitej vo widgete"
        },
        "SUBMIT_BUTTON": "Vytvoriť schránku",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa vytvoriť kanál webovej stránky, skúste to prosím znova"
        }
      },
      "TWILIO": {
        "TITLE": "Kanál Twilio SMS/WhatsApp",
        "DESC": "Integrujte Twilio a začnite podporovať svojich zákazníkov prostredníctvom SMS alebo WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "SID účtu",
          "PLACEHOLDER": "Zadajte prosím SID svojho účtu Twilio",
          "ERROR": "Toto pole je povinné"
        },
        "API_KEY": {
          "USE_API_KEY": "Použiť autentifikáciu pomocou API kľúča",
          "LABEL": "SID API kľúča",
          "PLACEHOLDER": "Zadajte prosím váš API Key SID",
          "ERROR": "Toto pole je povinné"
        },
        "API_KEY_SECRET": {
          "LABEL": "Tajný kľúč API",
          "PLACEHOLDER": "Zadajte prosím váš API Key Secret",
          "ERROR": "Toto pole je povinné"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "SID služby Messaging Service",
          "PLACEHOLDER": "Zadajte prosím váš Twilio Messaging Service SID",
          "ERROR": "Toto pole je povinné",
          "USE_MESSAGING_SERVICE": "Použiť Twilio Messaging Service"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Typ kanálu",
          "ERROR": "Prosím vyberte typ svojho kanálu"
        },
        "AUTH_TOKEN": {
          "LABEL": "Autentifikačný token",
          "PLACEHOLDER": "Zadajte svoj autentifikačný token pre Twilio",
          "ERROR": "Toto pole je povinné"
        },
        "CHANNEL_NAME": {
          "LABEL": "Meno schránky",
          "PLACEHOLDER": "Prosím vyplňte meno schránky",
          "ERROR": "Toto pole je povinné"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefónne číslo",
          "PLACEHOLDER": "Zadajte telefónne číslo, z ktorého bude správa odoslaná.",
          "ERROR": "Zadajte prosím platné telefónne číslo začínajúce znakom `+` a bez medzier."
        },
        "API_CALLBACK": {
          "TITLE": "URL spätného volania",
          "SUBTITLE": "V Twilio musíte nakonfigurovať URL spätného volania pre správy s URL uvedenou tu."
        },
        "SUBMIT_BUTTON": "Vytvoriť Twilio kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa overiť prihlasovacie údaje Twilio, skúste to prosím znova"
        }
      },
      "SMS": {
        "TITLE": "SMS kanál",
        "DESC": "Začnite podporovať svojich zákazníkov cez SMS.",
        "PROVIDERS": {
          "LABEL": "Poskytovateľ API",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandwidth",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa uložiť SMS kanál"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "ID účtu",
            "PLACEHOLDER": "Zadajte prosím vaše Bandwidth Account ID",
            "ERROR": "Toto pole je povinné"
          },
          "API_KEY": {
            "LABEL": "API kľúč",
            "PLACEHOLDER": "Zadajte prosím váš Bandwidth API Key",
            "ERROR": "Toto pole je povinné"
          },
          "API_SECRET": {
            "LABEL": "API Secret",
            "PLACEHOLDER": "Zadajte prosím váš Bandwidth API Secret",
            "ERROR": "Toto pole je povinné"
          },
          "APPLICATION_ID": {
            "LABEL": "ID aplikácie",
            "PLACEHOLDER": "Zadajte prosím vaše Bandwidth Application ID",
            "ERROR": "Toto pole je povinné"
          },
          "INBOX_NAME": {
            "LABEL": "Meno schránky",
            "PLACEHOLDER": "Prosím vyplňte meno schránky",
            "ERROR": "Toto pole je povinné"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefónne číslo",
            "PLACEHOLDER": "Zadajte telefónne číslo, z ktorého bude správa odoslaná.",
            "ERROR": "Zadajte prosím platné telefónne číslo začínajúce znakom `+` a bez medzier."
          },
          "SUBMIT_BUTTON": "Vytvoriť Bandwidth kanál",
          "API": {
            "ERROR_MESSAGE": "Nepodarilo sa overiť prihlasovacie údaje Bandwidth, skúste to prosím znova"
          },
          "API_CALLBACK": {
            "TITLE": "URL spätného volania",
            "SUBTITLE": "V Bandwidth musíte nakonfigurovať URL spätného volania pre správy s URL uvedenou tu."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Názov schránky",
            "PLACEHOLDER": "Zadajte prosím názov schránky",
            "ERROR": "Toto pole je povinné"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefónne číslo",
            "PLACEHOLDER": "Zadajte prosím telefónne číslo, z ktorého budú odosielané správy.",
            "ERROR": "Zadajte prosím platné telefónne číslo začínajúce znakom `+`."
          },
          "SUBMIT_BUTTON": "Vytvoriť kanál SMS Brana",
          "API": {
            "ERROR_MESSAGE": "Nepodarilo sa nám vytvoriť kanál SMS Brana"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Názov schránky",
            "PLACEHOLDER": "Zadajte prosím názov schránky",
            "ERROR": "Toto pole je povinné"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefónne číslo",
            "PLACEHOLDER": "Zadajte prosím telefónne číslo, z ktorého budú odosielané správy.",
            "ERROR": "Zadajte prosím platné telefónne číslo začínajúce znakom `+`."
          },
          "SUBMIT_BUTTON": "Vytvoriť kanál DIDWW",
          "API": {
            "ERROR_MESSAGE": "Nepodarilo sa nám vytvoriť kanál DIDWW"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "Poskytovateľ API",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Na Facebook Developer portáli musíte nakonfigurovať webhook URL a overovací token s hodnotami uvedenými nižšie.",
          "WEBHOOK_URL": "URL webhooku",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook overovací token"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Rýchle nastavenie cez Meta",
          "DESC": "Presmerujeme vás na Meta, kde sa prihlásite do svojho účtu WhatsApp Business. S administrátorským prístupom bude nastavenie jednoduché a plynulé.",
          "BENEFITS": {
            "EASY_SETUP": "Bez manuálnej konfigurácie",
            "SECURE_AUTH": "Bezpečné overenie cez OAuth",
            "AUTO_CONFIG": "Automatická konfigurácia webhooku a telefónneho čísla"
          },
          "SUBMIT_BUTTON": "Pripojiť WhatsApp Business",
          "AUTH_PROCESSING": "Prebieha overenie cez Meta",
          "WAITING_FOR_BUSINESS_INFO": "Dokončite nastavenie firmy v okne Meta...",
          "PROCESSING": "Nastavuje sa váš účet WhatsApp Business",
          "CANCELLED": "Registrácia WhatsApp bola zrušená",
          "WAITING_FOR_AUTH": "Čaká sa na overenie...",
          "INVALID_BUSINESS_DATA": "Z Facebooku prišli neplatné údaje o firme. Skúste to prosím znova.",
          "SIGNUP_ERROR": "Pri registrácii nastala chyba",
          "SDK_LOAD_ERROR": "Facebook SDK sa nepodarilo načítať. Skúste to znova.",
          "AUTH_NOT_COMPLETED": "Overenie nebolo dokončené. Spustite proces znova.",
          "SUCCESS_FALLBACK": "Účet WhatsApp Business bol úspešne nakonfigurovaný",
          "RECONNECTED": "Kanál WhatsApp bol úspešne znova pripojený"
        },
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa uložiť WhatsApp kanál"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API kanál",
        "DESC": "Integrujte sa s kanálom API a začnite podporovať svojich zákazníkov.",
        "CHANNEL_NAME": {
          "LABEL": "Názov kanálu",
          "PLACEHOLDER": "Zadajte názov kanála",
          "ERROR": "Toto pole je povinné"
        },
        "WEBHOOK_URL": {
          "LABEL": "URL webhooku",
          "SUBTITLE": "Nakonfigurujte URL, na ktorú chcete prijímať spätné volania na udalosti.",
          "PLACEHOLDER": "URL webhooku"
        },
        "SUBMIT_BUTTON": "Vytvoriť API kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa nám uložiť kanál API"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "Emailový kanál",
        "DESC": "Integrujte svoju e-mailovú schránku.",
        "CHANNEL_NAME": {
          "LABEL": "Názov kanálu",
          "PLACEHOLDER": "Zadajte názov kanála",
          "ERROR": "Toto pole je povinné"
        },
        "EMAIL": {
          "LABEL": "E-mail",
          "SUBTITLE": "E-mail, na ktorý vám zákazníci posielajú podporné tikety",
          "PLACEHOLDER": "E-mail"
        },
        "SUBMIT_BUTTON": "Vytvoriť e-mailový kanál",
        "API": {
          "ERROR_MESSAGE": "E-mailový kanál sa nám nepodarilo uložiť"
        },
        "FINISH_MESSAGE": "Začnite preposielať e-maily na túto e-mailovú adresu."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE kanál",
        "DESC": "Integrujte sa s kanálom LINE a začnite podporovať svojich zákazníkov.",
        "CHANNEL_NAME": {
          "LABEL": "Názov kanálu",
          "PLACEHOLDER": "Zadajte názov kanála",
          "ERROR": "Toto pole je povinné"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE kanál ID",
          "PLACEHOLDER": "LINE kanál ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE kanál Secret",
          "PLACEHOLDER": "LINE kanál Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE kanál Token",
          "PLACEHOLDER": "LINE kanál Token"
        },
        "SUBMIT_BUTTON": "Vytvorenie kanála LINE",
        "API": {
          "ERROR_MESSAGE": "Kanál LINE sa nepodarilo uložiť"
        },
        "API_CALLBACK": {
          "TITLE": "URL spätného volania",
          "SUBTITLE": "Musíte nakonfigurovať adresu URL webhooku v aplikácii LINE pomocou adresy URL uvedenej tu."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegramový kanál",
        "DESC": "Integrujte sa s kanálom Telegram a začnite podporovať svojich zákazníkov.",
        "BOT_TOKEN": {
          "LABEL": "Token pre bota",
          "SUBTITLE": "Nakonfigurujte token bota, ktorý ste získali od programu Telegram BotFather.",
          "PLACEHOLDER": "Token pre bota"
        },
        "SUBMIT_BUTTON": "Vytvoriť Telegram kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa uložiť Telegramový kanál"
        }
      },
      "AUTH": {
        "TITLE": "Vybrať kanál",
        "DESC": "Chat podporuje ako kanály live-chat widgety, Facebook Messenger, WhatsApp, e-maily a ďalšie. Ak chcete vytvoriť vlastný kanál, môžete ho vytvoriť pomocou API kanála. Na začiatok vyberte jeden z kanálov nižšie."
      },
      "AGENTS": {
        "TITLE": "Agenti",
        "DESC": "Tu môžete pridať agentov na správu novovytvorenej schránky. Len títo vybraní agenti budú mať prístup k vašej schránke. Agenti, ktorí nie sú súčasťou tejto schránky, nebudú môcť po prihlásení vidieť správy v tejto schránke ani na ne reagovať. <br> <b>PS:</b> Ak ako správca potrebujete prístup ku všetkým schránkam, mali by ste sa pridať ako agent ku všetkým vytvoreným schránkam.",
        "VALIDATION_ERROR": "Pridajte aspoň jedného agenta do novej schránky",
        "PICK_AGENTS": "Vyberte agentov pre schránku"
      },
      "DETAILS": {
        "TITLE": "Detaily schránky",
        "DESC": "Z rozbaľovacieho zoznamu nižšie vyberte stránku na Facebooku, ktorú chcete pripojiť k chatu. Pre lepšiu identifikáciu môžete schránke zadať aj vlastný názov."
      },
      "FINISH": {
        "TITLE": "Podarilo sa!",
        "DESC": "Úspešne ste dokončili integráciu svojej stránky na Facebooku s chatom. Keď vašej stránke nabudúce napíše zákazník, konverzácia sa automaticky zobrazí vo vašej schránke.<br>Poskytujeme vám aj skript widgetu, ktorý môžete jednoducho pridať na svoju webovú stránku. Keď bude na vašej webovej stránke funkčný, zákazníci vám môžu posielať správy priamo z nej bez akéhokoľvek externého nástroja a konverzácia sa objaví priamo tu, v chate.<br>Skvelé, však? Aspoň sa o to snažíme :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Vyberte svojho e-mailového poskytovateľa",
        "DESCRIPTION": "Vyberte e-mailového poskytovateľa zo zoznamu nižšie. Ak vášho poskytovateľa nevidíte v zozname, môžete vybrať možnosť iného poskytovateľa a zadať IMAP a SMTP prihlasovacie údaje."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft e-mail",
        "DESCRIPTION": "Kliknutím na tlačidlo Prihlásiť sa cez Microsoft začnite. Budete presmerovaní na prihlasovaciu stránku e-mailu. Po prijatí požadovaných oprávnení budete presmerovaní späť na krok vytvorenia schránky.",
        "EMAIL_PLACEHOLDER": "Zadajte e-mailovú adresu",
        "SIGN_IN": "Prihlásiť sa cez Microsoft",
        "ERROR_MESSAGE": "Pri pripájaní k Microsoftu nastala chyba, skúste to prosím znova"
      },
      "GOOGLE": {
        "TITLE": "Google e-mail",
        "DESCRIPTION": "Kliknutím na tlačidlo Prihlásiť sa cez Google začnite. Budete presmerovaní na prihlasovaciu stránku e-mailu. Po prijatí požadovaných oprávnení budete presmerovaní späť na krok vytvorenia schránky.",
        "SIGN_IN": "Prihlásiť sa cez Google",
        "EMAIL_PLACEHOLDER": "Zadajte e-mailovú adresu",
        "ERROR_MESSAGE": "Pri pripájaní ku Google nastala chyba, skúste to prosím znova"
      },
      "INTERNAL_NAME": {
        "LABEL": "Interný názov",
        "PLACEHOLDER": "Pomenujte schránku tak, ako sa zobrazí v tomto dashboarde",
        "ERROR": "Zadajte prosím jedinečný interný názov"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Pokračovať s Instagramom",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Pripojte svoj Instagram profil",
        "HELP": "Ak chcete pridať svoj Instagram profil ako kanál, musíte overiť svoj Instagram profil kliknutím na 'Pokračovať s Instagramom' ",
        "ERROR_MESSAGE": "Pri pripájaní k Instagramu došlo k chybe, skúste to prosím znova",
        "ERROR_AUTH": "Pri pripájaní k Instagramu došlo k chybe, skúste to prosím znova",
        "NEW_INBOX_SUGGESTION": "Tento Instagram účet bol predtým prepojený s inou schránkou a teraz bol migrovaný sem. Všetky nové správy sa zobrazia tu. Stará schránka už nebude môcť odosielať ani prijímať správy pre tento účet.",
        "DUPLICATE_INBOX_BANNER": "Tento Instagram účet bol migrovaný do novej schránky kanála Instagram. Z tejto schránky už nebudete môcť odosielať/prijímať Instagram správy."
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce kanál",
        "DESC": "Integrujte sa s kanálom Salesforce a začnite poskytovať podporu vašim zákazníkom.",
        "CHANNEL_NAME": {
          "LABEL": "Názov kanála",
          "PLACEHOLDER": "Zadajte prosím názov kanála",
          "ERROR": "Toto pole je povinné"
        },
        "API_BASE_URL": {
          "LABEL": "URL Salesforce API",
          "SUBTITLE": "Konfigurujte základnú URL pre vašu inštanciu Salesforce.",
          "PLACEHOLDER": "URL Salesforce API",
          "ERROR": "Toto pole je povinné"
        },
        "KEY_ID": {
          "LABEL": "ID kľúča",
          "SUBTITLE": "Key ID pre váš Salesforce kanál.",
          "PLACEHOLDER": "ID kľúča",
          "ERROR": "Toto pole je povinné"
        },
        "SECRET": {
          "LABEL": "Tajný kľúč",
          "SUBTITLE": "Secret pre váš Salesforce kanál.",
          "PLACEHOLDER": "*****",
          "ERROR": "Toto pole je povinné"
        },
        "SUBMIT_BUTTON": "Vytvoriť Salesforce kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa nám uložiť Salesforce kanál"
        },
        "API_CALLBACK": {
          "TITLE": "URL webhooku",
          "SUBTITLE": "V Salesforce musíte nakonfigurovať webhook URL tu uvedenou URL."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer token",
          "SUBTITLE": "Použite tento bearer token na overenie pri konfigurácii webhooku v Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "Prepísať odosielateľa e-mailu",
          "SUBTITLE": "Ak je nastavená, táto e-mailová adresa bude použitá ako odosielateľ všetkých odchádzajúcich e-mailov namiesto zdrojového e-mailu konverzácie.",
          "PLACEHOLDER": "napr. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro kanál",
        "DESC": "Pripojte predajný účet Allegro a odpovedajte na správy v jeho centre správ priamo z kontaktného centra.",
        "CHANNEL_NAME": {
          "LABEL": "Názov schránky",
          "SUBTITLE": "Názov, ktorý pri tejto schránke vidia agenti.",
          "PLACEHOLDER": "Zadajte názov schránky",
          "ERROR": "Toto pole je povinné"
        },
        "SUBMIT_BUTTON": "Prihlásiť sa cez Allegro",
        "API": {
          "ERROR_MESSAGE": "Pri pripájaní k Allegro nastala chyba, skúste to prosím znova"
        },
        "SELLER_LOGIN": {
          "TITLE": "Prihlásenie do Allegro",
          "SUBTITLE": "Predajný účet, ktorého správy táto schránka číta a odpovedá na ne."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland kanál",
        "DESC": "Odpovedajte na správy v tiketoch, ktoré vám kupujúci posielajú na trhovisku Kaufland.",
        "CHANNEL_NAME": {
          "LABEL": "Názov kanála",
          "PLACEHOLDER": "Zadajte prosím názov kanála",
          "ERROR": "Toto pole je povinné"
        },
        "CLIENT_KEY": {
          "LABEL": "Kľúč klienta",
          "SUBTITLE": "Client Key s 32 znakmi zo stránky nastavení API vášho predajného účtu Kaufland.",
          "PLACEHOLDER": "kľúč s 32 znakmi",
          "ERROR": "Zadajte Client Key s 32 znakmi"
        },
        "SECRET_KEY": {
          "LABEL": "Tajný kľúč",
          "SUBTITLE": "Secret Key so 64 znakmi, ktorý patrí ku Client Key. Kaufland ho zobrazí raz a na túto stránku sa už nikdy nevracia.",
          "PLACEHOLDER": "kľúč so 64 znakmi",
          "ERROR": "Zadajte Secret Key so 64 znakmi"
        },
        "SUBMIT_BUTTON": "Vytvoriť Kaufland kanál",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa nám uložiť Kaufland kanál"
        },
        "DISCONNECTED": {
          "TITLE": "Odpojené",
          "MESSAGE": "Kaufland odmietol tieto API kľúče. Zadajte Client Key a Secret Key znova a táto schránka sa znova pripojí."
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefónne hovory",
        "DESC": "Nastavte, ktoré telefónne hovory sa zobrazia v tejto schránke.",
        "NAME": {
          "LABEL": "Názov schránky",
          "SUBTITLE": "Zvoľte ľahko identifikovateľný názov."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefónne číslo",
          "SUBTITLE": "Zadajte telefónne čísla, ktoré patria do tejto schránky, neskôr môžete pridať ďalšie čísla.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Vytvoriť schránku telefónnych hovorov",
        "API": {
          "ERROR_MESSAGE": "Nepodarilo sa nám vytvoriť schránku"
        }
      }
    },
    "DETAILS": {
      "LOADING_FB": "Spájame vás s Facebookom...",
      "ERROR_FB_LOADING": "Chyba pri načítaní Facebook SDK. Deaktivujte prosím všetky blokátory reklám a skúste to znova z iného prehliadača.",
      "ERROR_FB_AUTH": "Niečo sa pokazilo, prosím, obnovte stránku...",
      "ERROR_FB_UNAUTHORIZED": "Nemáte oprávnenie vykonať túto akciu. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Uistite sa prosím, že máte prístup k Facebook stránke s plnou kontrolou. Viac informácií o Facebook rolách si môžete prečítať <a href=\" https://www.facebook.com/help/187316341316631\">tu</a>.",
      "ERROR_CHANNEL_CREATION": "Schránku sa nepodarilo vytvoriť. Skúste to prosím znova.",
      "CREATING_CHANNEL": "Vytvára sa vaša schránka...",
      "TITLE": "Konfigurovať detaily schránky",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Pridať agentov",
      "ADD_AGENTS": "Pridávajú sa agenti do schránky..."
    },
    "FINISH": {
      "TITLE": "Vaša schránka je pripravená!",
      "MESSAGE": "Teraz sa môžete spojiť so svojimi zákazníkmi cez váš nový kanál. Veľa úspechov pri podpore",
      "BUTTON_TEXT": "Prejsť tam",
      "MORE_SETTINGS": "Ďalšie nastavenia",
      "WEBSITE_SUCCESS": "Úspešne ste dokončili vytvorenie kanála webovej stránky. Skopírujte nižšie uvedený kód a vložte ho na svoju webovú stránku. Pri ďalšom použití živého chatu zákazníkom sa konverzácia automaticky objaví vo vašej schránke."
    },
    "REAUTH": "Opätovne autorizovať",
    "VIEW": "Zobraziť",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Úspešná aktualizácia nastavenia schránky",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatické priradenie bolo úspešne aktualizované",
        "ERROR_MESSAGE": "Nepodarilo sa aktualizovať nastavenia schránky. Skúste to prosím neskôr."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Meno odosielateľa",
        "SUB_TEXT": "Vyberte meno, ktoré sa zobrazí vášmu zákazníkovi, keď dostane e-maily od vašich agentov.",
        "FOR_EG": "Napríklad:",
        "FRIENDLY": {
          "TITLE": "Priateľský",
          "FROM": "z",
          "SUBTITLE": "Pridajte meno agenta, ktorý odoslal odpoveď, k menu odosielateľa, aby pôsobilo priateľsky."
        },
        "PROFESSIONAL": {
          "TITLE": "Profesionálny",
          "SUBTITLE": "Použite ako meno odosielateľa iba nakonfigurovaný názov firmy v hlavičke e-mailu."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Nakonfigurovať názov firmy",
          "PLACEHOLDER": "Zadajte názov firmy",
          "SAVE_BUTTON_TEXT": "Uložiť"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "ENABLE_HMAC": {
        "LABEL": "Zapnúť"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Zapnuté",
        "DISABLED": "Vypnuté"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Povolené",
        "DISABLED": "Zakázané"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Žiadna"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Povolené",
        "DISABLED": "Zakázané"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Povoliť synchronizáciu prichádzajúcich e-mailov"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Povoliť vlastnú e-mailovú doménu (platená služba)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Povoliť spracovanie Facebook komentárov"
      },
      "SIGNATURE": {
        "TITLE": "HTML podpis",
        "SUB_TEXT": "Tento podpis bude pridaný do päty každej správy odoslanej z tejto schránky.",
        "HTML_CONTENT": "HTML kód",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} bude nahradené menom agenta.\n{'{{'}email{'}}'} bude nahradené e-mailovou adresou agenta, ktorý odoslal e-mail.\n{'{{'}position{'}}'} bude nahradené pozíciou agenta.\n{'{{'}custom_line{'}}'} bude nahradené vlastným riadkom agenta.\n{'{{'}email_signature_picture{'}}'} bude nahradené adresou URL obrázka e-mailového podpisu agenta (nie značkou obrázka) — použite ju ako zdroj obrázka (atribút src značky img).",
        "PREVIEW": "Náhľad"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Podpisy podľa krajiny",
        "SUB_TEXT": "Odpoveď dostane podpis podľa krajiny zákazníka.",
        "HELP": "Odpoveď sa podpíše podľa krajiny konverzácie: podľa obchodu Kaufland, podľa trhu objednávky z Allegra, inak podľa jazyka, ktorým zákazník píše. Ak krajinu nepoznáme alebo tu pre ňu podpis chýba, použije sa HTML podpis vyššie. Marketplace zakazujú odkazy na web a kontaktné údaje, uveďte preto iba pozdrav a {'{{'}name{'}}'}.",
        "EMPTY": "Zatiaľ nemáte vytvorené podpisy pre konkrétne krajiny, odpovede preto dostanú HTML podpis vyššie.",
        "COUNTRY": "Vyberte krajinu",
        "ADD": "Pridať podpis pre krajinu",
        "REMOVE": "Odstrániť"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Predčíslie pri vytáčaní",
        "PLACEHOLDER": "Zadajte predčíslie pre správne smerovanie hovorov (napr. *99)",
        "HELP_TEXT": "Toto predčíslie bude automaticky pripojené pred telefónne čísla kontaktov pri vytáčaní z tejto schránky."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Text tlačidla „doriešime neskôr“",
        "PLACEHOLDER": "napr. Túto tému doriešime cez e-mail. Teraz sa chcem opýtať ešte na niečo iné.",
        "HELP_TEXT": "Text tlačidla vo widgete, ktorým návštevník opustí aktuálnu tému a opýta sa na niečo iné. Ak pole ostane prázdne, použije sa predvolený text v jazyku návštevníka."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Automaticky odložiť zmeškané hovory na X minút",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Automaticky odložiť zmeškané hovory na zadaný počet minút. Ponechajte prázdne alebo 0 pre zakázanie."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Vyriešiť zmeškaný hovor po X neúspešných spätných volaniach",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Keď sa na zmeškaný hovor X-krát zavolá späť a zákazník ho nezdvihne, automaticky sa vyrieši a pridá sa k nemu súkromná poznámka. Ponechajte prázdne alebo 0 pre zakázanie."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Návrhy otázok",
        "SUB_TEXT": "Konfigurujte preddefinované otázky, ktoré môžu zákazníci použiť na interakciu s vašimi agentmi.",
        "QUESTIONS_LABEL": "Otázky",
        "ADD_QUESTION": "Pridať otázku",
        "QUESTION": "Otázka",
        "REMOVE": "Odstrániť",
        "QUESTION_TEXT": "Text zobrazený v bubline.",
        "QUESTION_TEXT_PLACEHOLDER": "Povinné",
        "QUESTION_PAYLOAD": "Text odoslaný pri kliknutí.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Voliteľné",
        "SAVE": "Uložiť",
        "NO_BOT_MESSAGE": "Pre generovanie ďalších AI návrhov prosím pripojte bota.",
        "BOT_CONNECTED_MESSAGE": "AI návrhy otázok od bota je možné aktivovať v jeho",
        "BOT_SETTINGS_LINK": "nastaveniach"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternatívne e-maily",
        "SUB_TEXT": "Ďalšie adresy, ktoré má táto schránka považovať za vlastné pri prijímaní preposlanej pošty.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Pridať",
        "REMOVE": "Odstrániť",
        "EMPTY": "Nie sú nakonfigurované žiadne alternatívne e-maily.",
        "HELP_TEXT": "Keď príde e-mail s jednou z týchto adries ako príjemcom, odpovede sa odošlú s rovnakou adresou ako odosielateľom. Uistite sa, že váš odchádzajúci server SMTP povoľuje odosielanie z týchto adries.",
        "SIGNATURE_LABEL": "Podpis",
        "PRIMARY_SIGNATURE": "Hlavný (predvolený)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Ďalšie podpisy",
        "SUB_TEXT": "Tu definujte ďalšie podpisy a potom ich priraďte k alternatívnym e-mailom nižšie.",
        "OPTION": "Podpis {number}",
        "ADD": "Pridať podpis",
        "REMOVE": "Odstrániť",
        "HELP_TEXT": "Keď sa odpoveď odošle z alternatívneho e-mailu, namiesto podpisu schránky sa použije podpis priradený k tomuto e-mailu. Alternatívne e-maily ponechané na „Hlavný (predvolený)“ použijú podpis schránky."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "AVATAR_DELETE_BUTTON_TEXT": "Odstrániť avatar",
      "CONFIRM": {
        "TITLE": "Potvrdiť vymazanie",
        "MESSAGE": "Určite chcete vymazať ",
        "PLACE_HOLDER": "Na potvrdenie zadajte {inboxName}",
        "YES": "Áno, vymazať ",
        "NO": "Nie, ponechať "
      },
      "API": {
        "SUCCESS_MESSAGE": "Schránka bola úspešne odstránená",
        "ERROR_MESSAGE": "Nepodarilo sa odstrániť schránku. Skúste to prosím neskôr.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar schránky bol úspešne odstránený",
        "AVATAR_ERROR_MESSAGE": "Nepodarilo sa odstrániť avatar schránky. Skúste to prosím neskôr.",
        "MARKED_FOR_DELETION_MESSAGE": "Schránka bola označená na odstránenie",
        "RESTORE_SUCCESS_MESSAGE": "Schránka bola úspešne obnovená",
        "RESTORE_ERROR_MESSAGE": "Nepodarilo sa obnoviť schránku. Skúste to prosím neskôr."
      },
      "DELETE_REQUESTED_TOOLTIP": "Táto schránka je označená na odstránenie",
      "RESTORE_BUTTON_TEXT": "Obnoviť"
    },
    "TABS": {
      "SETTINGS": "Nastavenia",
      "COLLABORATORS": "Spolupracovníci",
      "CONFIGURATION": "Konfigurácia",
      "CAMPAIGN": "Kampane",
      "PRE_CHAT_FORM": "Formulár pred chatom",
      "BUSINESS_HOURS": "Otváracie hodiny",
      "WIDGET_BUILDER": "Tvorca widgetov",
      "BOT_CONFIGURATION": "Konfigurácia bota",
      "SLA": "SLA",
      "AUTOMATIC_PRIORITY": "Automatická priorita",
      "AUTOMATIC_LABELING": "Automatické označovanie"
    },
    "SETTINGS": "Nastavenia",
    "FEATURES": {
      "LABEL": "Funkcie",
      "DISPLAY_FILE_PICKER": "Zobraziť výber súborov vo widgete",
      "DISPLAY_EMOJI_PICKER": "Zobraziť výber emoji vo widgete",
      "ALLOW_END_CONVERSATION": "Povoliť používateľom ukončiť konverzáciu z widgetu",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Zobraziť v hlavičke widgetu tlačidlo pre začatie novej konverzácie",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Skryť vstupné pole, keď je zobrazené tlačidlo pre začatie novej konverzácie",
      "SHOW_HANDOFF_BUTTON": "Zobraziť tlačidlo 'Prepojiť na operátora' v hlavičke widgetu",
      "USE_INBOX_AVATAR_FOR_BOT": "Použiť názov a avatar schránky pre bota",
      "ALLOW_OFFLINE_REPLY": "Povoliť agentom odosielať správy, keď je kontakt offline a kontinuita e-mailu nie je k dispozícii",
      "AUTO_CLOSE_OLD": "Označiť všetky predchádzajúce hovory z rovnakého čísla ako vyriešené po vyriešení jedného",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Automaticky priradiť zmeškané hovory pri uskutočňovaní odchádzajúceho hovoru"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger Script",
      "MESSENGER_SUB_HEAD": "Umiestnite toto tlačidlo dovnútra tagu body",
      "INBOX_AGENTS": "Agenti",
      "INBOX_AGENTS_SUB_TEXT": "Add or remove agents from this inbox",
      "AGENT_ASSIGNMENT": "Priradenie konverzácie",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Aktualizovať nastavenia priradenia konverzácií",
      "UPDATE": "Aktualizovať",
      "ENABLE_EMAIL_COLLECT_BOX": "Povoliť pole pre zber e-mailov",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "Povoliť alebo zakázať pole pre zber e-mailov pri novej konverzácii",
      "AUTO_ASSIGNMENT": "Povoliť automatické priradenie",
      "ENABLE_CSAT": "Povoliť CSAT",
      "SENDER_NAME_SECTION": "Povoliť meno agenta v e-maile",
      "ENABLE_CSAT_SUB_TEXT": "Povoliť/zakázať CSAT (prieskum spokojnosti zákazníkov) po vyriešení konverzácie",
      "SENDER_NAME_SECTION_TEXT": "Povoliť/zakázať zobrazenie mena agenta v e-maile, ak je zakázané, zobrazí sa názov firmy",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Povoliť pokračovanie konverzácie cez e-mail",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Konverzácie budú pokračovať cez e-mail, ak je dostupná e-mailová adresa kontaktu.",
      "LOCK_TO_SINGLE_CONVERSATION": "Obmedziť na jednu konverzáciu",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Povoliť alebo zakázať viacero konverzácií pre ten istý kontakt v tejto schránke",
      "INBOX_UPDATE_TITLE": "Nastavenia schránky",
      "INBOX_UPDATE_SUB_TEXT": "Aktualizujte nastavenia svojej schránky",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Povoliť alebo zakázať automatické priradenie nových konverzácií agentom pridaným do tejto schránky.",
      "HMAC_VERIFICATION": "Overenie identity používateľa",
      "HMAC_DESCRIPTION": "Pomocou tohto kľúča môžete vygenerovať tajný token, ktorý môžete použiť na overenie identity svojich používateľov.",
      "HMAC_LINK_TO_DOCS": "Viac si môžete prečítať tu.",
      "HMAC_MANDATORY_VERIFICATION": "Vynucovanie overovania totožnosti používateľa",
      "HMAC_MANDATORY_DESCRIPTION": "Ak je povolené, požiadavky, ktoré sa nedajú overiť, budú odmietnuté.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Vynútiť novú konverzáciu pri každom načítaní widgetu",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Ak je povolené, otvorenie widgetu na novej karte alebo v novom okne začne novú konverzáciu.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Zabudnúť kontakt pri začatí novej konverzácie",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Ak je vypnuté, nová konverzácia začatá z widgetu zachová predchádzajúci kontakt.",
      "INBOX_IDENTIFIER": "Indetifikátor schránky",
      "INBOX_IDENTIFIER_SUB_TEXT": "Na overenie klientov API použite tu uvedený token `inbox_identifier`.",
      "FORWARD_EMAIL_TITLE": "Preposlanť na e-mail",
      "FORWARD_EMAIL_SUB_TEXT": "Začnite preposielať e-maily na túto e-mailovú adresu.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Povoliť správy po vyriešení konverzácie",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Povoliť koncovým používateľom odosielať správy aj po vyriešení konverzácie.",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Aktualizovať nastavenia formulára pred chatom",
      "INBOX_TEAMS": "Tímy",
      "INBOX_COOPERATORS": "Spolupracovníci",
      "SELECT_PLACEHOLDER": "Vybrať",
      "AGENTS_OR_TEAMS_INFO": "Môžete priradiť buď agentov alebo tímy - nie súčasne oboje.",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "Povoliť CSAT pre každú správu",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "Povoliť/zakázať možnosť CSAT prieskumu pre každú správu odoslanú agentmi",
      "RESPOND_FROM_EMAIL": "Odpovedať z e-mailu",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-maily zákazníkovi — odpovede aj prepisy konverzácií — sa odosielajú cez nastavenia SMTP vybranej e-mailovej schránky z vybranej adresy (vlastnej adresy schránky alebo jedného z jej aliasov) a odpovede zákazníka prichádzajú späť cez jej adresu IMAP.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Prepisy konverzácií sa odosielajú cez nastavenia SMTP vybranej e-mailovej schránky z vybranej adresy (vlastnej adresy schránky alebo jedného z jej aliasov) a odpovede prichádzajú späť cez jej adresu IMAP.",
      "SHOW_WELCOME_SCREEN": "Zobraziť uvítaciu obrazovku",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Zobraziť uvítaciu obrazovku pri otvorení widgetu. Ak je zakázané, widget pôjde priamo na zobrazenie konverzácie.",
      "AUTO_CLOSE_PENDING": "Automaticky vyriešiť AI chaty po (hodinách)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "Automaticky vyriešiť AI chaty po X hodinách neaktivity.",
      "HMAC_ROTATE": {
        "BUTTON": "Vymeniť kľúč",
        "TITLE": "Vymeniť tajný kľúč?",
        "WARNING": "Aktuálny kľúč prestane platiť v okamihu výmeny.",
        "WARNING_DETAIL": "Starý a nový kľúč nefungujú súčasne a starý kľúč nemožno obnoviť.",
        "IMPACT": "Vaše servery musia používateľov podpisovať novým kľúčom. Kto je podpísaný starým kľúčom, overením neprejde. Ak je overenie identity povinné, nemôže začať konverzáciu.",
        "CONFIRM": "Vymeniť kľúč",
        "CANCEL": "Zrušiť",
        "SUCCESS": "Tajný kľúč bol úspešne vymenený",
        "ERROR": "Tajný kľúč sa nepodarilo vymeniť, skúste to prosím znova"
      },
      "EMAIL_FETCHING_ENABLED_TITLE": "Synchronizácia e-mailov",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Povoliť automatickú synchronizáciu a sťahovanie prichádzajúcich e-mailov z tejto schránky",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Vlastná e-mailová doména",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Povoliť použitie vlastnej e-mailovej domény pre odchádzajúce e-maily",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Môžete si prečítať viac tu.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook komentáre",
      "WIDGET_STATUS_LABEL": "Stav widgetu",
      "WIDGET_STATUS_ENABLED": "Povolené",
      "WIDGET_STATUS_BUSINESS_HOURS": "Povolené počas pracovných hodín",
      "WIDGET_STATUS_DISABLED": "Zakázané",
      "WIDGET_STATUS_HELP_TEXT": "Kontrolujte, kedy sa widget zobrazí návštevníkom na vašej webovej stránke",
      "EXPLICIT_CSAT_LOCALE": "Jazyk CSAT prieskumu a e-mailov",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Vyberte jazyk pre všetky zákaznícke e-maily vrátane CSAT prieskumov, prepisov konverzácií a e-mailových notifikácií",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Podľa účtu",
      "WHATSAPP_CONNECTION": {
        "TITLE": "Pripojenie WhatsApp",
        "SUBTITLE": "Ako je táto schránka pripojená k WhatsAppu.",
        "PROVIDER": "Poskytovateľ",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Pripojené cez registráciu Meta (embedded signup)",
        "STATUS": "Stav",
        "CONNECTED": "Pripojené",
        "RECONNECT_HINT": "Kliknite na Znova pripojiť v pruhu hore.",
        "PHONE_NUMBER": "Telefónne číslo",
        "BUSINESS_ACCOUNT": "ID účtu WhatsApp Business",
        "OPEN_MANAGER": "Otvoriť vo WhatsApp Manageri",
        "PHONE_NUMBER_ID": "ID telefónneho čísla",
        "TEMPLATES": "Šablóny správ",
        "TEMPLATES_COUNT": "Schválené {approved} z {total}",
        "TEMPLATES_SYNCED": "Naposledy synchronizované {date}",
        "TEMPLATES_NOT_SYNCED": "Zatiaľ nesynchronizované",
        "MANAGE_TEMPLATES": "Spravovať šablóny"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Centrum pomoci",
      "PLACEHOLDER": "Vyberte centrum pomoci",
      "SELECT_PLACEHOLDER": "Vyberte centrum pomoci",
      "REMOVE": "Odstrániť centrum pomoci",
      "SUB_TEXT": "Pripojiť centrum pomoci k schránke"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limit automatického priradenia",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Zadajte prosím hodnotu väčšiu ako 0",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Obmedziť maximálny počet konverzácií z tejto schránky, ktoré možno automaticky priradiť agentovi"
    },
    "SLA": {
      "TITLE": "Nastavenie SLA",
      "SUB_TEXT": "Nastavte SLA časy odozvy a riešenia pre každú úroveň priority konverzácie.",
      "LOADING": "Načítavanie SLA nastavení...",
      "FIELDS": {
        "ACTIVE": "Aktívne",
        "TICKET_PRIORITY": "Priorita tiketu",
        "FIRST_RESPONSE_TIME": "Čas prvej reakcie",
        "EVERY_RESPONSE_TIME": "Čas každej reakcie",
        "RESOLUTION_TIME": "Doba vyriešenia tiketu",
        "PLACEHOLDER": "napr. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA nastavenie boli úspešne aktualizované.",
        "ERROR_MESSAGE": "Nepodarilo sa aktualizovať SLA nastavenie. Skúste to prosím znova."
      }
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Znova autorizovať",
      "SUBTITLE": "Vaše pripojenie k Facebooku vypršalo, pre pokračovanie v službách prosím znovu pripojte svoju stránku na Facebooku",
      "MESSAGE_SUCCESS": "Opätovné pripojenie bolo úspešné",
      "MESSAGE_ERROR": "Vyskytla sa chyba, skúste to prosím znova"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Formuláre pred konverzáciou vám umožnia zachytiť informácie o používateľovi ešte predtým, ako s vami začne konverzovať.",
      "SET_FIELDS": "Polia formulára pred chatom",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Polia",
        "LABEL": "Štítok",
        "PLACE_HOLDER": "Zástupný text",
        "KEY": "Kľúč",
        "TYPE": "Typ",
        "REQUIRED": "Povinné"
      },
      "ENABLE": {
        "LABEL": "Povoliť formulár pred konverzáciou",
        "OPTIONS": {
          "ENABLED": "Áno",
          "DISABLED": "Nie"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Správa pred konverzáciou",
        "PLACEHOLDER": "Táto správa sa zobrazí používateľom spolu s formulárom"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Pred začatím chatu by mali návštevníci uviesť svoje meno a e-mailovú adresu"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Nastavte svoju dostupnosť",
      "SUBTITLE": "Nastavenie dostupnosti na widgete livechatu",
      "WEEKLY_TITLE": "Nastaviť týždnový rozvrh",
      "TIMEZONE_LABEL": "Vybrať časové pásmo",
      "UPDATE": "Aktualizácia nastavení otváracích hodín",
      "TOGGLE_AVAILABILITY": "Povoliť nastavenie otváracích hodín pre túto schránku",
      "UNAVAILABLE_MESSAGE_LABEL": "Správa pre návštevníkov pri nedostupnosti",
      "TOGGLE_HELP": "Povolenie obchodnej dostupnosti zobrazí dostupné hodiny na widgete živého chatu, aj keď sú všetci agenti offline. Mimo dostupných hodín môžu byť návštevníci upozornení správou a formulárom pred chatom.",
      "DAY": {
        "ENABLE": "Povolenie dostupnosti pre tento deň",
        "UNAVAILABLE": "Neodstupné",
        "HOURS": "hodiny",
        "VALIDATION_ERROR": "Začiatočný čas by mal byť pred zatváracím časom.",
        "CHOOSE": "Vybrať"
      },
      "ALL_DAY": "Celý deň",
      "SAVE_TO_ALL": "Uložiť do všetkých schránok",
      "SAVE_TO_ALL_TITLE": "Kopírovať pracovné hodiny",
      "SAVE_TO_ALL_CONFIRM": "Nastavenia z tohto formulára (prepínač dostupnosti, správa mimo kancelárie, časová zóna a pracovné hodiny) budú skopírované do všetkých ostatných schránok okrem e-mailových a telefónnych schránok. Naozaj chcete pokračovať?",
      "SAVE_TO_ALL_CANCEL": "Zrušiť",
      "SAVE_TO_ALL_YES": "Áno, kopírovať do všetkých",
      "SAVE_TO_ALL_SUCCESS": "Pracovné hodiny boli úspešne skopírované do všetkých ostatných schránok",
      "SAVE_TO_ALL_ERROR": "Nepodarilo sa skopírovať pracovné hodiny do ostatných schránok"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Nastaviť IMAP detaily",
      "NOTE_TEXT": "Na povolenie SMTP prosím nakonfigurujte IMAP.",
      "UPDATE": "Aktualizovať IMAP nastavenia",
      "TOGGLE_AVAILABILITY": "Povolenie konfigurácie IMAP pre túto schránku",
      "TOGGLE_HELP": "Povolenie IMAP pomôže používateľovi prijímať e-maily",
      "EDIT": {
        "SUCCESS_MESSAGE": "Úspešná aktualizácia nastavení IMAP",
        "ERROR_MESSAGE": "Nebolo možné aktualizovať nastavenia IMAP"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (napr. imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prihlásenie",
        "PLACE_HOLDER": "Prihlásenie"
      },
      "PASSWORD": {
        "LABEL": "Heslo",
        "PLACE_HOLDER": "Heslo"
      },
      "ENABLE_SSL": "Povoliť SSL"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "Opätovne autorizujte svoj MICROSOFT účet"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Nastaviť SMTP detaily",
      "UPDATE": "Aktualizovať SMTP nastavenia",
      "TOGGLE_AVAILABILITY": "Povoliť konfiguráciu SMTP pre túto schránku",
      "TOGGLE_HELP": "Povolenie SMTP pomôže používateľovi odosielať e-maily",
      "EDIT": {
        "SUCCESS_MESSAGE": "Nastavenia SMTP boli úspešne aktualizované",
        "ERROR_MESSAGE": "Nepodarilo sa aktualizovať nastavenia SMTP"
      },
      "ADDRESS": {
        "LABEL": "Adresa",
        "PLACE_HOLDER": "Adresa (napr.: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Prihlásenie",
        "PLACE_HOLDER": "Prihlásenie"
      },
      "PASSWORD": {
        "LABEL": "Heslo",
        "PLACE_HOLDER": "Heslo"
      },
      "DOMAIN": {
        "LABEL": "Doména",
        "PLACE_HOLDER": "Doména"
      },
      "ENCRYPTION": "Šifrovanie",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "Režim overovania Open SSL",
      "AUTH_MECHANISM": "Autentifikácia"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "Doručiteľnosť e-mailov (DNS)",
      "SUB_TITLE": "Záznamy SPF, DKIM, DMARC a MX domény {domain} kontrolujeme každý pracovný deň. Keď niečo spôsobuje, že prijímajúce servery vaše odpovede odmietajú alebo ich radia do spamu, administrátori dostanú e-mail s postupom opravy.",
      "RUN": "Spustiť kontrolu",
      "RUN_SUCCESS": "Kontrola DNS skončila",
      "RUN_ERROR": "Kontrolu DNS sa nepodarilo spustiť, skúste to prosím znova",
      "NOT_CHECKED": "Zatiaľ nekontrolované.",
      "CHECKED_AT": "Naposledy skontrolované {time}.",
      "DNS_UNAVAILABLE": "Pri poslednej kontrole neodpovedali názvové servery domény. Nižšie je výsledok predchádzajúcej kontroly.",
      "SENDER": {
        "SMTP": "Odpovede sa odosielajú cez {host}.",
        "PLATFORM": "Odpovede sa odosielajú cez naše poštové servery."
      },
      "STATUS": {
        "OK": "Všetky záznamy sú v poriadku",
        "WARNING": "Niektoré záznamy by mohli byť lepšie",
        "ERROR": "Odpovede sa nemusia dostať k príjemcom",
        "UNKNOWN": "Neznámy"
      },
      "SEVERITY": {
        "ERROR": "Problém",
        "WARNING": "Upozornenie"
      },
      "FIX": "Opravte to týmto DNS záznamom:",
      "RECORD_TYPE": "Typ",
      "RECORD_HOST": "Názov",
      "RECORD_VALUE": "Hodnota",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "Chýba záznam SPF",
          "DESCRIPTION": "Doména neuvádza, ktoré servery môžu posielať jej e-maily. Mnohé poštové servery potom považujú vaše odpovede za spam. Pridajte záznam SPF, ktorý povoľuje {sender}."
        },
        "spf_multiple": {
          "TITLE": "Doména má {count} záznamov SPF",
          "DESCRIPTION": "Doména môže mať iba jeden záznam SPF. Ak ich je viac, prijímajúce servery SPF ignorujú a e-maily často odmietajú. Zlúčte ich do jedného záznamu."
        },
        "spf_not_authorized": {
          "TITLE": "SPF nepovoľuje server, ktorý odosiela vaše odpovede",
          "DESCRIPTION": "Vaše odpovede sa odosielajú cez {sender}, ale záznam SPF domény ho neobsahuje. Aktuálny záznam: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Záznam SPF vyžaduje príliš veľa DNS dopytov",
          "DESCRIPTION": "Prijímajúce servery prestanú kontrolovať SPF po {limit} DNS dopytoch, ale {sender}, ktorý odosiela vaše odpovede, sa dosiahne až po {lookups}. Vaše odpovede v SPF zlyhajú. Presuňte {sender} na začiatok záznamu a odstráňte položky include, ktoré doména už nepoužíva."
        },
        "spf_lookups_others": {
          "TITLE": "Niektorí odosielatelia v zázname SPF sú za limitom dopytov",
          "DESCRIPTION": "Záznam SPF vyžaduje {lookups} DNS dopytov, prijímajúce servery sa zastavia po {limit}. Vaše odpovede sa priradia včas a prejdú, ale e-maily od týchto odosielateľov v SPF zlyhajú: {senders}. Odstráňte položky include, ktoré doména už nepoužíva."
        },
        "spf_malformed": {
          "TITLE": "Záznam SPF je chybný",
          "DESCRIPTION": "Prijímajúce servery nedokážu záznam SPF domény prečítať, takže vaše odpovede nechráni. Problém je v: {terms}. Nahraďte záznam opraveným."
        },
        "dkim_missing": {
          "TITLE": "Podpis DKIM nie je nastavený",
          "DESCRIPTION": "Na {selectors} sme nenašli žiadny kľúč DKIM. Bez neho nie sú vaše odpovede podpísané a skôr skončia v spame. Zapnite podpisovanie DKIM pre doménu u svojho poskytovateľa e-mailu."
        },
        "dmarc_missing": {
          "TITLE": "Chýba záznam DMARC",
          "DESCRIPTION": "Veľkí poskytovatelia pošty, ako Gmail a Microsoft, záznam DMARC očakávajú. Bez neho vaše odpovede skôr skončia v spame."
        },
        "dmarc_fails": {
          "TITLE": "DMARC prikazuje príjemcom odmietať vaše odpovede",
          "DESCRIPTION": "Politika DMARC domény je „{policy}“ a vaše odpovede neprejdú ani cez SPF, ani cez DKIM, preto ich príjemcovia odmietajú alebo presúvajú do spamu. Opravte SPF a DKIM vyššie."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blokuje odpovede odosielané cez naše poštové servery",
          "DESCRIPTION": "Táto schránka odosiela odpovede cez naše poštové servery, ale politika DMARC domény je „{policy}“, preto ich príjemcovia odmietajú alebo presúvajú do spamu. Nastavte pre túto schránku SMTP vlastného poštového servera."
        },
        "mx_missing": {
          "TITLE": "Doména nemá záznam MX",
          "DESCRIPTION": "Bez záznamu MX nikto nemôže poslať e-mail na doménu, takže zákazníci nemôžu odpovedať na vaše správy."
        }
      }
    },
    "NOTE": "Poznámka: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Avatar webovej stránky",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar bol úspešne odstránený",
              "ERROR_MESSAGE": "Vyskytla sa chyba, skúste to prosím znova"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Názov webovej stránky",
          "PLACE_HOLDER": "Zadajte názov vašej webovej stránky (napr.: Acme Inc)",
          "ERROR": "Zadajte prosím platný názov webovej stránky"
        },
        "WELCOME_HEADING": {
          "LABEL": "Uvítací nadpis",
          "PLACE_HOLDER": "Dobrý deň!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Uvítací slogan",
          "PLACE_HOLDER": "Spojenie s nami je jednoduché. Spýtajte sa nás na čokoľvek alebo sa podeľte o svoju spätnú väzbu."
        },
        "REPLY_TIME": {
          "LABEL": "Čas odpovede",
          "IN_A_FEW_MINUTES": "O pár minút",
          "IN_A_FEW_HOURS": "O pár hodín",
          "IN_A_DAY": "O deň"
        },
        "WIDGET_COLOR_LABEL": "Farba widgetu",
        "WIDGET_BUBBLE_POSITION_LABEL": "Pozícia bubliny widgetu",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maximálna výška neprečítaných správ (px)",
          "PLACE_HOLDER": "Bez obmedzenia",
          "HELP_TEXT": "Obmedzte maximálnu výšku vyskakovacieho okna neprečítaných správ v pixeloch. Ponechajte prázdne pre predvolené správanie (bez obmedzenia)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Typ bubliny widgetu",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Četujte s nami",
          "LABEL": "Titulok spúšťača bubliny widgetu",
          "PLACE_HOLDER": "Četujte s nami"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Aktualizovať nastavenia widgetu",
          "API": {
            "SUCCESS_MESSAGE": "Nastavenia widgetu boli úspešne aktualizované",
            "ERROR_MESSAGE": "Nepodarilo sa aktualizovať nastavenia widgetu"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Náhľad",
          "SCRIPT": "Skript"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Vľavo",
          "RIGHT": "Vpravo"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Štandardná",
          "EXPANDED_BUBBLE": "Rozšírená bublina"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Predvolené",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Zvyčajne odpovedá do niekoľkých minút",
        "IN_A_FEW_HOURS": "Zvyčajne odpovedá do niekoľkých hodín",
        "IN_A_DAY": "Zvyčajne odpovedá do dňa"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Začať konverzáciu",
        "CHAT_INPUT_PLACEHOLDER": "Zadajte svoju správu"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Sme online",
          "OFFLINE": "Momentálne nie sme k dispozícii"
        },
        "USER_MESSAGE": "Dobrý deň",
        "AGENT_MESSAGE": "Dobrý deň"
      },
      "BRANDING_TEXT": "Powered by JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Ostatní poskytovatelia"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Webová stránka",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-mail",
      "TELEGRAM": "Telegram",
      "LINE": "Line",
      "API": "API kanál",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "PHONE": "SIP telefón",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatická priorita",
      "SUB_TEXT": "Konfigurujte automatické priradenie priority na základe obsahu konverzácie.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Upozornenie o platbe",
        "MESSAGE": "Každé vyhodnotenie priority bude spoplatnené. Skontrolujte prosím detaily vášho plánu pre informácie o cenách."
      },
      "MODE": {
        "OFF": "Vypnuté",
        "ALL_MESSAGES": "Zapnuté pre všetky prichádzajúce správy",
        "FIRST_MESSAGE": "Zapnuté iba pre prvú prichádzajúcu správu"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Konfigurácia úrovní priority",
        "SUB_TEXT": "Konfigurujte, ktoré úrovne priority majú byť povolené a ich popisy. Poskytnite jasné kritériá pre AI, aby určila, kedy má byť priradená táto priorita."
      },
      "DESCRIPTION_LABEL": "Popis",
      "DESCRIPTION_PLACEHOLDER": "Popíšte konverzácie, ktoré majú byť označené prioritou {priority}",
      "SET_AS_DEFAULT": "Nastaviť ako predvolenú prioritu",
      "MULTIPLE_DEFAULTS_WARNING": "Iba jedna úroveň priority by mala byť nastavená ako predvolená. Zrušte prosím ostatné predvolené."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatické označovanie",
      "SUB_TEXT": "Konfigurujte automatické priradenie štítkov na základe obsahu konverzácie.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Upozornenie o platbe",
        "MESSAGE": "Každé vyhodnotenie označovania bude spoplatnené. Skontrolujte prosím detaily vášho plánu pre informácie o cenách."
      },
      "MODE": {
        "OFF": "Vypnuté",
        "CONVERSATION_OPEN": "Pri otvorení konverzácie",
        "CONVERSATION_CLOSE": "Pri uzavretí konverzácie",
        "ALL_MESSAGES": "Pri každej správe - bez ohľadu na stav",
        "FIRST_MESSAGE": "Pri prvej správe - bez ohľadu na stav"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Konfigurácia štítkov",
        "SUB_TEXT": "Konfigurujte, ktoré štítky majú byť dostupné pre automatické priradenie a ich popisy. Poskytnite jasné kritériá pre AI, aby určila, kedy má byť tento štítok použitý."
      },
      "DESCRIPTION_LABEL": "Popis",
      "DESCRIPTION_PLACEHOLDER": "Popíšte konverzácie, ktoré majú byť označené ako {label}. Ak necháte prázdne, použije sa popis štítka.",
      "NO_LABELS_MESSAGE": "Neboli nájdené žiadne štítky. Najprv vytvorte štítky pre povolenie automatického označovania.",
      "CREATE_LABELS_LINK": "Vytvoriť štítky"
    },
    "PHONE": {
      "TITLE": "Nastavenia telefónu",
      "SUBTITLE": "Konfigurujte, ktoré hovory sa zobrazia v tejto schránke.",
      "UPDATE": "Uložiť nastavenia",
      "EDIT": {
        "SUCCESS_MESSAGE": "Nastavenia telefónu aktualizované",
        "ERROR_MESSAGE": "Nepodarilo sa aktualizovať nastavenia telefónu"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefónne čísla",
        "SUBTITLE": "Zadajte telefónne čísla, ktoré patria do tejto schránky.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Pridať telefónne číslo"
      }
    }
  }
}
